url = process.env.VUE_APP_ENDPOINT;
maintenance = !!parseInt(process.env.VUE_APP_MAINTENANCE);
accessLiga = false;
